import View from '@shared/components/layout-default/layout-default-router-view';

const predictive_connect = [
  {
    path: 'predictive',
    component: View,
    meta: {
      permissions: ['module_predictive_is_disabled']
    },
    children: [
      {
        path: '',
        name: 'predictive_connect.index',
        redirect: {
          name: 'predictive_connect'
        }
      },

      {
        path: 'connect',
        name: 'predictive_connect',
        component: () =>
          import(
            /* webpackChunkName: 'predictive_connect' */
            '@predictive_connect/pages/predictive-connect-page'
          ),
        meta: {
          title: {
            code: 'predictive_connect.breadcrumb.trunk.index'
          }
        }
      }
    ]
  }
];
export { predictive_connect };
